import React from "react";
import { Route, Routes } from "react-router-dom";
import SignIn from "./components/SignIn";
import ForgetPassword from "./components/ForgetPassword";
import ResetPassword from "./components/ResetPassword";

const AuthApp = () => {
  // const authUser = useSelector((state) => state.auth.authUser);
  // const [childComponent, setChildComponent] = useState(authUser && <ViewProfile authUser={ authUser } record={ { id: authUser.employment_id, employee_id: authUser.employee_id } } onCompleted={ onCompleted } />)

  return (
    <>
      <Routes>
        <Route path="/" element={ <SignIn /> } />
        {/* <Route path="/signin" element={ <SignIn /> } /> */}
        <Route path="/forgetPassword" element={ <ForgetPassword /> } />
        <Route path="/reset-password" element={ <ResetPassword /> } />
        <Route path="/user/reset-password" element={ <ResetPassword /> } />
        {/* <Route path="/profile" element={ childComponent } /> */ }
      </Routes>
    </>
  )
}

export default AuthApp;
